import type { FaireProductEntity } from "../../entity_types/product";

export const p_2h79rmxjbn: FaireProductEntity = {
  token: "p_2h79rmxjbn",
  type: "product",
  name: "Sitting Buddha Praying",
  brandToken: "b_6clm7lye",
  brandName: "Hi-Line Gift Ltd.",
  imageUrl:
    "https://cdn.faire.com/fastly/8ca02f5e52767342bab32c782a0d46776853d1db8699fa8abd87fbcc911a826e.jpeg",
  galleryImageUrls: [],
  priceDollars: 24.25,
  description:
    "Add this beautiful Buddha statue to your zen space. Made from durable polyresin. A perfect addition to your lawn or garden. Ideal for indoor and outdoor use.",
  tags: [],
  msrpDollars: 53,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:27.663Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
